import { z } from 'zod';
/**
 * The JSON a robot posts on its `robot.capabilities` stream (RB-0b, FI-9).
 * formant-isaac-sim's bridge posts it every 60 s
 * (`fsim.formant.manifest.capabilities_payload`); real robots may not publish
 * it at all, so every consumer must have a fallback. The contract here is
 * deliberately lenient (unknown keys pass through, most fields optional) so a
 * newer sim can add fields without breaking cortex.
 */
export const robotCapabilitiesStreamName = 'robot.capabilities';
/** One command the robot accepts. */
export const RobotCapabilityCommandSchema = z
    .object({
    /** Canonical action name (`goto_waypoint`, `goto_pose`, `take_off`, ...). */
    action: z.string().min(1),
    /** Formant command template name to issue (what issue_command takes). */
    template: z.string().min(1).optional(),
    /** The command name the robot's agent filters on; usually equals template. */
    command: z.string().min(1).optional(),
    /** Command family (`base_goto`, `flight`, `dock`, ...); null for bridge-local actions. */
    family: z.string().nullable().optional(),
    /** Parameter format: `envelope` (JSON), `bare`, or `key_value`. Absent = envelope. */
    dialect: z.string().nullable().optional(),
    /** When the robot answers the command: `at_terminal` (default) or `on_accept`. */
    respond: z.string().nullable().optional(),
    /** Canonical argument name -> the robot's own key. */
    arg_map: z.record(z.string(), z.string()).nullable().optional(),
    /** JSON Schema of the command's arguments object (`properties`, `required`). */
    arguments: z.unknown().optional(),
})
    .passthrough();
export const RobotCapabilitiesPayloadSchema = z
    .object({
    robot_id: z.string().optional(),
    /** Robot definition id (`go2`, `spot`, `x500`, ...). */
    robot: z.string().optional(),
    /** Robot category (`quadruped`, `amr`, `drone`, `arm`, ...). */
    category: z.string().optional(),
    profile: z.string().nullable().optional(),
    /** Declared capabilities, each `{ "<capability>": { ...options } }` (e.g. `locomotion.aerial`). */
    capabilities: z.array(z.record(z.string(), z.unknown())).optional(),
    commands: z.array(RobotCapabilityCommandSchema),
    /** Canonical stream name -> the stream name this robot actually uses. */
    streams: z.record(z.string(), z.string()).optional(),
})
    .passthrough();
//# sourceMappingURL=robot-capabilities.js.map